import api from './api';
// 获取产品列表
export function getProductList(params) {
  return api.post('/product/list.html', params, true, false).then(res => res);
}
// 添加产品信息
export function addProduct(params) {
  return api.post('/product/save.html', params).then(res => res);
}
// 删除产品信息
export function deleteProduct(params) {
  return api.post('/product/del.html', params).then(res => res);
}
// 获取产品详情
export function getProductDetail(params) {
  return api.post('/product/info', params, false, false).then(res => res);
}
// 更新产品信息
export function updateProduct(params) {
  return api.post('/product/update.html', params, false, false).then(res => res);
}
// 审核产品
export function auditProduct(params) {
  return api.post('/product/audit.html', params, false, false).then(res => res);
}
// 推荐产品至首页
export function recommendProduct(params) {
  return api.post('/product/recommend.html', params, false, false).then(res => res);
}
// 获取产品类型
export function getProductType() {
  return api.post('/dic/getdiclistbypid', {
    pid: 16
  }, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/product.js